<template>
	<div>
		<div
			v-for="(skipass, index) in cart.skipass"
			:key="skipass.uniqueId"
			class="cart-list__item grid-x"
		>
			<div class="cell small-3 medium-2">
				<!-- Image -->
				<img class="cart-list__image" :src="skipass.image" alt="cart image" />
			</div>

			<div class="cell small-9 medium-2 cart-list__mobile-header">
				<!-- Head in mobile -->
				<span class="cart-list__item-no">
					{{ $t('skipass.skipass') }} {{ index + 1 }}
				</span>
				<span class="cart-list__heading cart-list__heading--small">
					{{ skipass.name }}
					{{ skipass.ageGroup ? `(${skipass.ageGroup})` : '' }}
				</span>
				<span class="cart-list__validity">
					{{ $t('skipass.valid') }}
					{{ formatDateSpan(skipass.begindate, skipass.length) }}
				</span>
			</div>
			<div class="cell small-12 medium-10">
				<!-- Buttons -->
				<div class="cart-list__buttons">
					<Button
						size="square"
						color="red"
						@click.native="
							() =>
								!skipass.detlid ? showRemoveProductModal(skipass) : () => {}
						"
						:disabled="skipass.detlid ? true : false"
					>
						<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M21.19 4.22l-1.41-1.41L12 10.59 4.22 2.81 2.81 4.22 10.59 12l-7.78 7.78 1.41 1.41L12 13.41l7.78 7.78 1.41-1.41L13.41 12l7.78-7.78z"/></svg>
					</Button>
				</div>

				<!-- Card -->
				<div class="cart-list__card">
					<!-- Head -->
					<div class="cart-list__head cart-list__head--with-border grid-x">
						<div class="cell small-12 medium-9">
							<span class="cart-list__item-no">
								{{ $t('skipass.skipass') }} {{ index + 1 }}
							</span>
							<span class="cart-list__heading">
								{{ skipass.name }}
								{{ skipass.ageGroup ? `(${skipass.ageGroup})` : '' }}&nbsp;
								<span v-if="skipass.displayLength">
									{{ skipass.displayLength }}
								</span>

								<LabelBox v-if="hasDiscount(skipass) && !cart.resvid">
									<template>
										-{{ discountPrice(skipass) }} {{ cart.currency }}
									</template>
								</LabelBox>
							</span>
							<span class="cart-list__validity">
								{{ $t('skipass.valid') }}
								{{ formatDateSpan(skipass.begindate, skipass.length) }}
							</span>
						</div>
						<div class="cart-list__price cell small-12 medium-3">
							<!-- <span class="cart-list__heading">
								{{ convertPrice(skipass.price) }} SEK
							</span> -->
							<span
								class="cart-list__heading"
								v-if="hasDiscount(skipass) == false"
							>
								{{ convertPrice(skipass.price) }} {{ cart.currency }}
							</span>
							<div class="cart-list__heading price" v-else>
								<div v-if="cart.resvid">
									{{ convertPrice(skipass.price) }}
									{{ cart.currency }}
								</div>
								<div v-else class="price__discount">
									{{ convertPrice(skipass.price) }}
									{{ cart.currency }}
								</div>
								<div v-if="!cart.resvid" class="price__full">
									<span class="price__label">{{ $t('cart.fullPrice') }}</span>
									{{ convertPrice(skipass.ordinaryPrice) }}
									{{ cart.currency }}
								</div>
							</div>
							<!-- <div class="cart-list__price cell small-12 medium-4" v-else>
								
							</div> -->
						</div>
					</div>

					<!-- Body -->
					<div class="cart-list__body cart-list__body--with-upper-border">
						<!-- Fast checkout -->
						<CartCardFastCheckout
							:product="skipass"
							v-if="!isLoggedIn() && cart.fastCheckout"
						/>

						<!-- Standard checkout -->
						<SetProductCompanion
							v-if="isLoggedIn() || !cart.fastCheckout"
							:product="skipass"
							:productType="'skipass'"
						/>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal: Remove product -->
		<Modal
			v-show="showModal"
			:disableClose="true"
			:maxWidth="640"
			:heading="$t('cart.remove')"
			:text="
				this.product.name +
				' (' +
				this.product.ageGroup +
				') ' +
				product.displayLength
			"
			:closeCta="true"
			:closeCtaText="$t('cart.close')"
			@close="showModal = false"
		>
			<template v-slot:buttons>
				<Button @click.native="removeProduct(product.uniqueId)">
					{{ $t('cart.remove') }}
				</Button>
			</template>
		</Modal>
	</div>
</template>

<script>
import store from '../../vueX/store'
import mixin from '../../mixin'

import Button from '../atoms/Button'
import SetProductCompanion from '../molecules/SetProductCompanion'
import Modal from '../molecules/Modal'
import LabelBox from '../atoms/LabelBox'
import CartCardFastCheckout from '../molecules/CartCardFastCheckout'

export default {
	name: 'CartSkipass',
	store,
	mixins: [mixin],
	components: {
		SetProductCompanion,
		Button,
		Modal,
		LabelBox,
		CartCardFastCheckout
	},
	data() {
		return {
			showModal: false,
			product: {
				name: '',
				uniqueId: '',
				ageGroup: '',
				displayLength: ''
			}
		}
	},
	props: {},
	computed: {
		cart() {
			return store.state.cart
		},
		user() {
			return store.state.user
		}
	},
	methods: {
		isLoggedIn() {
			return store.state.user != null
		},
		activeGuest(id) {
			return this.user.guests.find(each => each.guestlid == id)
		},
		//To do - move to action?
		showRemoveProductModal(product) {
			this.product.name = product.name
			this.product.uniqueId = product.uniqueId
			this.product.ageGroup = product.ageGroup
			this.product.displayLength = product.displayLength

			this.showModal = true
		},
		removeProduct(id) {
			store
				.dispatch('REMOVE_CART_SKIPASS', {
					uniqueId: id
				})
				.then(() => {
					this.product.name = ''
					this.product.uniqueId = ''
					this.product.ageGroup = ''
					this.product.displayLength = ''

					this.showModal = false

					if (store.state.cart.cartCheckoutClicked) {
						store.dispatch('VALIDATE_PRODUCTS_IN_CART')
					}
				})
		},
		hasDiscount(skipass) {
			// could be refactored into a service "A"
			if (
				skipass.promotion !== undefined &&
				skipass.promotion !== null &&
				skipass.promotion.promotioncode !== ''
			) {
				return true
			}

			return false
		},
		discountPrice(skipass) {
			// could be refactored into a service "A"
			return skipass.ordinaryPrice - skipass.price
		}
	}
}
</script>

<style lang="scss" scoped>
.price {
	// ToDo: refactor into common atom for all .price thing used in this project
	&__discount {
		color: #e15b5b;
	}
	&__full {
		font-size: 13px;
		line-height: 20px;
		font-weight: 400;

		.price__label {
			color: $colorPrimary5;
		}
	}
}
.cart-list__heading {
	display: flex;
	align-items: center;

	.label-box {
		margin-left: 5px;
	}

	&.price {
		flex-flow: column;
		align-items: flex-end;
	}
}
</style>
